import { createFileRoute } from "@tanstack/react-router"
import { Wrapper } from "./-CarouselIdPage"

export const Route = createFileRoute("/prototypes/carousels/$carouselId")({ component: Wrapper })
